import React, { useEffect, useState } from 'react';
import {
  Box,
  Stack,
  Grid,
  Avatar,
  Tooltip,
  IconButton,
  Typography,
  FormControl,
  Button,
  Divider,
} from '@mui/material';
import { BsFillTrashFill, BsPlus } from 'react-icons/bs';
import { ComboBox } from 'components';
import ApiServices from 'services';
import Storage from 'storage';

const renderUserBox = (title, userCode, userList = [], onDelete) => (
  <>
    <Typography variant="h6" mt={1} mb={0.5}>
      Danh sách {title}
    </Typography>
    <Box
      sx={{
        width: '100%',
        minHeight: '200px',
        maxHeight: '550px',
        backgroundColor: '#FFF',
        boxShadow:
          'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px',
        borderRadius: '5px',
      }}
    >
      <Grid container>
        <Grid item xs={2} sx={{ padding: 1 }}>
          <Typography m={1} align="center" fontWeight="bold">
            Avatar
          </Typography>
        </Grid>
        <Grid item xs={3} sx={{ padding: 1 }}>
          <Typography m={1} align="center" fontWeight="bold">
            Mã
          </Typography>
        </Grid>
        <Grid item xs={5} sx={{ padding: 1 }}>
          <Typography m={1} align="center" fontWeight="bold">
            Tên
          </Typography>
        </Grid>
        <Grid item xs={2} sx={{ padding: 1 }}>
          <Typography m={1} align="center" fontWeight="bold">
            Tác vụ
          </Typography>
        </Grid>
      </Grid>

      {userList.map((item) => (
        <div key={item.code}>
          <Divider />
          <Grid container>
            <Grid item xs={2} sx={{ padding: 1, paddingLeft: 2 }}>
              <Avatar src={`${process.env.REACT_APP_API_URL}/${item?.urlAvatar}`} alt={item.code} />
            </Grid>
            <Grid item xs={3} sx={{ padding: 1 }}>{item?.code}</Grid>
            <Grid item xs={5} sx={{ padding: 1 }}>{item?.name}</Grid>
            <Grid item xs={2} sx={{ padding: 1, paddingLeft: 3 }}>
              <Tooltip title="Xóa">
                <span>
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => onDelete(item.code)}
                    disabled={userCode === item.code && title === 'Sales'}
                  >
                    <BsFillTrashFill />
                  </IconButton>
                </span>
              </Tooltip>
            </Grid>
          </Grid>
        </div>
      ))}
    </Box>
  </>
);

const PopupUserSupervisor = ({
  clientCareHistoryItem,
  getClientCareHistoryDetails,
  dataMainUserById,
  setDataMainUserById,
}) => {
  const [personName, setPersonName] = React.useState([]);
  const [csPersonName, setCsPersonName] = React.useState([]);

  const onHandleChangeFn = (e, newValue) => setPersonName(newValue);
  const onHandleChangeSupportFn = (e, newValue) => setCsPersonName(newValue);
  const getListByPositionId = async (position, idClientCareHistory = '') => {
    try {
      const { data } = await ApiServices.getListByPositionId(position, idClientCareHistory);
      if (data && idClientCareHistory) {
        setDataMainUserById(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateClientandUserMain = async (id, data) => {
    try {
      const { status } = await ApiServices.updateClientandUserMain(id, data);
      if (status === 200) {
        getClientCareHistoryDetails(id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onAddUser = async (fieldName) => {
    const allNames = [...(personName || []), ...(csPersonName || [])];

    if (allNames.length > 0) {
      const idSend = allNames.map((item) => item.code).filter(Boolean);
      const existing = Array.isArray(clientCareHistoryItem[fieldName])
        ? clientCareHistoryItem[fieldName].filter(Boolean)
        : [];

      const merged = [...new Set([...idSend, ...existing])];

      await updateClientandUserMain(clientCareHistoryItem.id, {
        [fieldName]: merged,
      });

      await getListByPositionId('admin', clientCareHistoryItem.id);
      await setPersonName([]);
      await setCsPersonName([]);
    }
  };

  const onDeleteUser = (fieldName) => async (code) => {
    const currentList = clientCareHistoryItem?.[fieldName] || [];
    const updatedList = currentList.filter((item) => item !== code);

    await updateClientandUserMain(clientCareHistoryItem.id, { [fieldName]: updatedList });
    await getListByPositionId('admin', clientCareHistoryItem.id);
  };

  const [userCode, setUserCode] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      const retrievedUser = await Storage.retrieveUser();
      if (retrievedUser) {
        setUserCode(retrievedUser.Code);
      }
    };
    fetchUser();
  }, []);

  return (
    <>
      <Typography variant="h6" mt={1}>
        Sales<span style={{ color: 'red' }}>(*)</span>
      </Typography>
      <Stack direction="row" alignItems="center">
        <FormControl sx={{ width: 500 }}>
          <ComboBox
            multiple
            disableCloseOnSelect
            label="Sales"
            options={dataMainUserById}
            keyField="name"
            value={personName}
            onChange={onHandleChangeFn}
          />
        </FormControl>
        <Button
          variant="contained"
          size="small"
          startIcon={<BsPlus />}
          onClick={() => onAddUser('arrMainUserCode')}
          sx={{
            borderRadius: '20px',
            textTransform: 'none',
            marginLeft: '8px',
            color: '#FFFFFF',
            backgroundColor: '#21409A',
            padding: '5px 15px',
          }}
        >
          Thêm
        </Button>
      </Stack>

      {renderUserBox(
        'Sales',
        userCode,
        clientCareHistoryItem?.arrMainUserobj,
        onDeleteUser('arrMainUserCode')
      )}

      <Typography variant="h6" mt={1.5}>
        CS
      </Typography>
      <Stack direction="row" alignItems="center">
        <FormControl sx={{ width: 500 }}>
          <ComboBox
            multiple
            disableCloseOnSelect
            label="CS"
            options={dataMainUserById}
            keyField="name"
            value={csPersonName}
            onChange={onHandleChangeSupportFn}
          />
        </FormControl>
        <Button
          variant="contained"
          size="small"
          startIcon={<BsPlus />}
          onClick={() => onAddUser('arrSecondaryUserCode')}
          sx={{
            borderRadius: '20px',
            textTransform: 'none',
            marginLeft: '8px',
            color: '#FFFFFF',
            backgroundColor: '#21409A',
            padding: '5px 15px',
          }}
        >
          Thêm
        </Button>
      </Stack>

      {renderUserBox(
        'CS',
        userCode,
        clientCareHistoryItem?.arrSecondaryUserobj,
        onDeleteUser('arrSecondaryUserCode')
      )}
    </>
  );
};

export default PopupUserSupervisor;